<template>
  <div>
    <a-drawer title="合同详情" :width="drawerWidth" @close="onClose" :visible="visible">
      <a-spin :spinning="spinning">
        <div v-for="(item,index) in details" :key="index">
        <a-row >
          <div style="font-size:16px">{{item.subjectidDesc}}</div>
          <a-col :span="8">
            <span class="text">合同表记录编号: </span>
            <span class="text">{{item.frecid}}</span>
          </a-col>
          <a-col :span="8">
            <span class="text">合同编号: </span>
            <span class="text">{{item.contno}}</span>
          </a-col>
          <a-col :span="8">
            <span class="text">付费方式 : </span>
            <span class="text">{{item.feetypeDesc}}</span>
          </a-col>
          <a-col :span="8">
            <span class="text">科目学时费用 : </span>
            <span class="text">{{FormatMoney(item.subjectfee) }}元</span>
          </a-col>
          <a-col :span="8">
            <span class="text">科目基本学时 : </span>
            <span class="text">{{item.subjecthour}}</span>
          </a-col>
          <a-col :span="8">
            <span class="text">科目合同总学时 : </span>
            <span class="text">{{item.consubjecthour}}</span>
          </a-col>
          <a-col :span="8">
            <span class="text">预付培训费金额 : </span>
            <span class="text">{{FormatMoney(item.suptution)}}元</span>
          </a-col>
          <a-col :span="8">
            <span class="text">学时单价 : </span>
            <span class="text">{{FormatMoney(item.price)}}元</span>
          </a-col>
          <a-col :span="8">
            <span class="text">已付费学时 : </span>
            <span class="text">{{item.timepaied}}</span>
          </a-col>
          <a-col :span="8">
            <span class="text">溢出学时 : </span>
            <span class="text">{{item.timesplil}}</span>
          </a-col>
          <a-col :span="8">
            <span class="text">已支付费用 : </span>
            <span class="text">{{FormatMoney(item.feepaid)}}元</span>
          </a-col>
          <a-col :span="8">
            <span class="text">课堂学时 : </span>
            <span class="text">{{item.consubhour1}}</span>
          </a-col>
          <a-col :span="8">
            <span class="text">网络学时 : </span>
            <span class="text">{{item.consubhour2}}</span>
          </a-col>
          <a-col :span="8">
            <span class="text">模拟训练 : </span>
            <span class="text">{{item.consubhour3}}</span>
          </a-col>
          <a-col :span="8">
            <span class="text">实际操作 : </span>
            <span class="text">{{item.consubhour4}}</span>
          </a-col>
          <a-col :span="8">
            <span class="text">其他方式 : </span>
            <span class="text">{{item.consubhour5}}</span>
          </a-col>
          <a-col :span="8">
            <span class="text">课堂学时费 : </span>
            <span class="text">{{FormatMoney(item.consubfee1)}}元</span>
          </a-col>
          <a-col :span="8">
            <span class="text">网络学时费 : </span>
            <span class="text">{{FormatMoney(item.consubfee2)}}元</span>
          </a-col>
          <a-col :span="8">
            <span class="text">模拟训练费 : </span>
            <span class="text">{{FormatMoney(item.consubfee3)}}元</span>
          </a-col>
          <a-col :span="8">
            <span class="text">实际操作费 : </span>
            <span class="text">{{FormatMoney(item.consubfee4)}}元</span>
          </a-col>
          <a-col :span="8">
            <span class="text">其他方式费 : </span>
            <span class="text">{{FormatMoney(item.consubfee5)}}元</span>
          </a-col>
          <a-col :span="8">
            <span class="text">在途金额 : </span>
            <span class="text">{{FormatMoney(item.onpayamt)}}元</span>
          </a-col>
        </a-row>
        <a-divider />
        </div>
      </a-spin>
      
    </a-drawer>
    
  </div>
</template>
<script>

export default {
  name: "ContractDetails",
  props: ["contractDetails"],
  
  data() {
    return {
      visible: false,
      drawerWidth: document.body.clientWidth * 0.7,
      spinning: false,
      details: [],
    };
  },
  created() {
    const that = this;
    this.visible = true;
    this.fetch();
    
  },
  computed: {
  },
  methods: {
    onClose() {
      this.visible = false;
      this.$emit("close");
    },
    fetch() {
      const that = this;
      that.spinning = true;
        that.$http.post(
            that.$marco.api.contractDetails,
            {
                contno:this.contractDetails.contno,
                drivschid:this.contractDetails.drivschid
            },
            data => {
                that.spinning = false;
                that.details = data;
                this.$log.success('合同详情 '+JSON.stringify(data));
            },
            errorDesc => {
                that.spinning = false;
                this.$log.normal(JSON.stringify(errorDesc));
            },
            error => {
                that.spinning = false;
                this.$log.error(JSON.stringify(error));
            },
            that
        );
    },
    FormatMoney(money){
      if(!money) return '0.00';
      return parseFloat(money/100).toFixed(2)
    }
  }
};
</script>
<style scoped>
.text{
  font-size: 14px;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.847);
}
.ant-col-8{
  margin-bottom:5px
}
</style>